import { ALL_BUYER_DIALOG_FAIL, ALL_BUYER_DIALOG_REQUEST, ALL_BUYER_DIALOG_SUCCESS, ALL_REPORT_FAIL, ALL_REPORT_REQUEST, ALL_REPORT_SUCCESS, CDR_DETAILS_FAIL, CDR_DETAILS_REQUEST, CDR_DETAILS_RESET, CDR_DETAILS_SUCCESS, CDR_SIP_LOG_FAIL, CDR_SIP_LOG_REQUEST, CDR_SIP_LOG_RESET, CDR_SIP_LOG_SUCCESS, CREATE_ADMIN_BLOCK_REPORT_FAIL, CREATE_ADMIN_BLOCK_REPORT_REQUEST, CREATE_ADMIN_BLOCK_REPORT_SUCCESS } from "../constants/reportConstants"

export const reportReducers = (state = { users: [] }, action) => {

    switch (action.type) {
        case ALL_REPORT_REQUEST:

            return {
                ...state,
                loading: true,
            }
        case ALL_REPORT_SUCCESS:

            return {
                ...state,
                loading: false,
                report: action.payload
            }
        case ALL_REPORT_FAIL:

            return {
                ...state,
                loading: false,
                error: action.payload

            }

        default:
            return state
    }

}

export const blockReportReducers = (state = { users: [] }, action) => {

    switch (action.type) {
        case CREATE_ADMIN_BLOCK_REPORT_REQUEST:

            return {
                ...state,
                loading: true,
            }
        case CREATE_ADMIN_BLOCK_REPORT_SUCCESS:

            return {
                ...state,
                loading: false,
                blockReport: action.payload
            }
        case CREATE_ADMIN_BLOCK_REPORT_FAIL:

            return {
                ...state,
                loading: false,
                error: action.payload

            }

        default:
            return state
    }

}

const initialCdrDetailsState = {
    loading: false,
    data: null,
    error: null,
    sipLog: { loading: false, data: null, error: null },
};

export const cdrDetailsReducer = (state = initialCdrDetailsState, action) => {
    switch (action.type) {
        case CDR_DETAILS_REQUEST:
            return { ...initialCdrDetailsState, loading: true };
        case CDR_DETAILS_SUCCESS:
            return { ...state, loading: false, data: action.payload, error: null };
        case CDR_DETAILS_FAIL:
            return { ...state, loading: false, data: null, error: action.payload };
        case CDR_DETAILS_RESET:
            return initialCdrDetailsState;
        case CDR_SIP_LOG_REQUEST:
            return { ...state, sipLog: { loading: true, data: null, error: null } };
        case CDR_SIP_LOG_SUCCESS:
            return { ...state, sipLog: { loading: false, data: action.payload, error: null } };
        case CDR_SIP_LOG_FAIL:
            return { ...state, sipLog: { loading: false, data: null, error: action.payload } };
        case CDR_SIP_LOG_RESET:
            return { ...state, sipLog: { loading: false, data: null, error: null } };
        default:
            return state;
    }
};

export const buyerDialogReducers = (state = { users: [] }, action) => {

    switch (action.type) {
        case ALL_BUYER_DIALOG_REQUEST:

            return {
                ...state,
                loading: true,
            }
        case ALL_BUYER_DIALOG_SUCCESS:

            return {
                ...state,
                loading: false,
                buyer_dialog: action.payload
            }
        case ALL_BUYER_DIALOG_FAIL:

            return {
                ...state,
                loading: false,
                error: action.payload

            }

        default:
            return state
    }

}